import { Radio as RadioMantine } from '@mantine/core'
import React, { useCallback, useEffect, useState } from 'react'

import { api_gateway } from '../../../conexoes/api'
import { useGlobal } from '../../../stores/useGlobal'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import Botao from '../../Mantine/Botao'
import Modal from '../../Mantine/Modal'
import Radio from '../../Mantine/Radio'

import * as S from './styles'

const ALERTAS = {
  padrao: {
    open: false,
    mensagem: ''
  },
  maximo: {
    titulo: 'Atenção!',
    open: true,
    mensagem:
      'O máximo permitido para essa ação é de até 50 portadoras selecionadas.'
  },
  invalidas: {
    open: true,
    titulo: 'Atenção!',
    mensagem:
      'Apenas portadoras Públicas ou Privada/Pública podem ter a classificação de rede alterada.'
  },
  sucesso: {
    open: true,
    isSuccess: true
  }
}

const CD_PORTRADORA_TIPO = {
  privadaPublica: '4',
  Publica: '6'
}

export default function AlterarClassificacaoDeRede({
  refetchPortadoras,
  selecionados
}) {
  const [alerta, setAlerta] = useState(ALERTAS.padrao)
  const [selected, setSelected] = useState()

  const {
    setMostrarAcao,
    setMostrarNotificacao,
    setIsLoadingGlobal,
    selecionarParqueInteiro
  } = useGlobal()

  const atualizarSimcards = useCallback(() => {
    const hasInvalidPortadora = selecionados.some(
      (item) => item.portadoraTipo === 'Privada'
    )

    if (hasInvalidPortadora) {
      setAlerta(ALERTAS.invalidas)
      return
    }

    if (selecionados?.length > 50 || selecionarParqueInteiro) {
      setAlerta(ALERTAS.maximo)
      return
    }
  }, [selecionados, selecionarParqueInteiro])

  useEffect(() => {
    atualizarSimcards()
  }, [selecionados, atualizarSimcards, selecionarParqueInteiro])

  const handleFecharMensagem = () => {
    setAlerta(ALERTAS.padrao)
    handleClose()
  }

  const handleRadioChange = (value) => setSelected(value)

  const handleClose = () => setMostrarAcao(undefined)

  const handleSucesso = () => {
    handleFecharMensagem()
    refetchPortadoras()
  }

  const handleSubmit = async () => {
    const cdPortadorasSelecionadas = selecionados.map((item) => item.id)

    setIsLoadingGlobal(true)
    await api_gateway
      .post('/api/v2/carriers/updateCarrierType', {
        carrierID: cdPortadorasSelecionadas,
        carrierTypeID: Number(selected)
      })
      .then(() => {
        setAlerta(ALERTAS.sucesso)
      })
      .catch(() => {
        setMostrarNotificacao({
          show: true,
          type: 'error',
          title: 'Falha ao alterar classificação de rede',
          message:
            'Não foi possível alterar classificação de rede, tente novamente.'
        })
      })
      .finally(() => {
        setIsLoadingGlobal(false)
      })
  }

  return (
    <>
      {!alerta.open && (
        <Modal
          width="450px"
          titulo="Alterar classificação de rede"
          opened
          disableConfirm={!selected}
          close={handleClose}
          onConfirm={handleSubmit}
        >
          <S.ContentWrapper>
            <S.Text>Alterar classificação de rede para:</S.Text>
            <RadioMantine.Group
              name="classificacao"
              value={selected}
              onChange={handleRadioChange}
            >
              <S.InputRadioGrupo>
                <Radio label="Pública" value={CD_PORTRADORA_TIPO.Publica} />
                <Radio
                  label="Privada/Pública"
                  value={CD_PORTRADORA_TIPO.privadaPublica}
                />
              </S.InputRadioGrupo>
            </RadioMantine.Group>
          </S.ContentWrapper>
        </Modal>
      )}

      {alerta.open && !alerta.isSuccess && (
        <Modal
          opened={alerta.open}
          width="445px"
          minHeight={alerta.titulo ? '180px' : '130px'}
          type="alerta"
        >
          <S.ContainerAlerta>
            {alerta.titulo && <S.TituloAlerta>{alerta.titulo}</S.TituloAlerta>}
            <S.MensagemAlerta>{alerta.mensagem}</S.MensagemAlerta>
            <Botao label="Fechar" onClick={handleFecharMensagem} />
          </S.ContainerAlerta>
        </Modal>
      )}

      {alerta.open && alerta.isSuccess && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1="Classificação de rede alterada."
              mensagemBotao="Continuar"
            />
          </div>
        </div>
      )}
    </>
  )
}
